import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "./welcome.sass";
import { useNavigate } from "react-router-dom";

import { useStep } from "../context/StepContext"
import { FaCheck } from "react-icons/fa";
import { BASE, getClientKey, getPrivacyNoticeUrl } from "../basedata/constants";
const CheckIcon = FaCheck as React.ComponentType<React.SVGProps<SVGSVGElement>>;

const Welcome = () => {
  const { t } = useTranslation();
  const [accepted, setAccepted] = useState(false);
  const [canSignup] = useState(BASE.company.signup_block !== false);
  const navigate = useNavigate();
  const { setStep } = useStep();

  const handleAcceptTerms = () => {
    setAccepted(!accepted);
  };

  const handleContinue = () => {
    if (accepted) {
      navigate("/signup");
    }
  }

  const initialized = useRef(false)
  useEffect(() => {
    setStep(-1);

    const fullName = localStorage.getItem("name");
      if(fullName)
        localStorage.removeItem("name");
      
    if (!initialized.current) {

      const params = new URLSearchParams(window.location.search)
      const currentToken = params.get('token'),
      currentCompany = params.get('orc')
  
    if(currentToken){
      sessionStorage.setItem('token', `${currentToken}`)
      sessionStorage.setItem('originCompany', `${currentCompany}`)
      window.location.href = `/validating?token=${currentToken}`
    }

    initialized.current = true

  }
  }, [])


  if (!canSignup) {
    return (
      <div className="main-container">
        <div className="welcome-card">
          <h1 className="bepass-title">{t("welcome_block_message.title")}</h1>
          <p className="bepass-text-default">{t("welcome_block_message.quote")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="main-container">
      <div className="welcome-card">
        <h1 className="bepass-title">{t("welcome_page.title")}</h1>
        <p className="bepass-text-default">{t(getClientKey("welcome_page.description"), { company_name: BASE.company.name })}</p>

        <div className="terms-container">
          <label htmlFor="accept-terms" className="checkbox-label">
            <input
              type="checkbox"
              id="accept-terms"
              checked={accepted}
              onChange={handleAcceptTerms}
            />
            <span className={`custom-check ${accepted ? 'checked' : ''}`}>
              {accepted && <CheckIcon className="check-icon"/>}
            </span>

            <span className="terms-text">
              {t(getClientKey("terms_message_start"))}{' '}
              <a
                href={getPrivacyNoticeUrl()}
                rel="noreferrer noopener"
                target="_blank"
                className="bold-link"
              >
                {t(getClientKey("bepass_privacy_biometry_terms"))}
              </a>
            </span>
          </label>
        </div>

        <button disabled={!accepted} className="continue-button"
          onClick={handleContinue}
        >
          {t("continue_button")}
        </button>
      </div>
   </div>
  );
};

export default Welcome;
